<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Variações do produto {{ product.title }}</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>

      <div class="c-modalCard__body">
        <div class="l-row variation" v-for="variation in product.variations">
          <div class="l-col-2@md img-product">
            <img :src="variation.images[0].url" alt="">
          </div>

          <div class="l-col-10@md">
            <div class="l-row">
              <div class="l-col-4@md">
                <div class="margin">
                  <strong>SKU Fonte</strong>
                  {{ variation.sku | attribute }}
                </div>
              </div>

              <div class="l-col-4@md">
                <div class="margin">
                  <strong>EAN</strong>
                  {{ variation.ean | attribute }}
                </div>
              </div>

              <div class="l-col-4@md" v-for="attribute in variation.attributes">
                <div class="margin">
                  <strong>{{ attribute.name }}</strong>
                  {{ attribute.value_name ? attribute.value_name : attribute.value_id  | attribute }}
                </div>
              </div>

              <div class="l-col-4@md">
                <div class="margin">
                  <strong>{{ $t('quantity.label') }}</strong>
                  {{ variation.stock.quantity | attribute }}
                </div>
              </div>

              <div class="l-col-4@md">
                <div class="margin">
                  <strong>{{ $t('price.label') }}</strong>
                  <span class="oldPrice">{{ variation.price.previous | currency }} /</span>
                  <span class="newPrice">{{ variation.price.current | currency }} </span>
                </div>
              </div>

              <div class="l-col-4@md">
                <div class="margin">
                  <strong>{{ $t('status.label') }}</strong>
                  <span  class="badge" :class="product.status">{{ $t(`${product.status}.label`) }}</span>
                </div>
              </div>
              <div class="l-col-4@md">
                <div class="margin">
                  <strong>{{ $t('saleAvailability.label') }}</strong>
                  <span  class="badge" :class="variation.saleAvailability.status">{{ $t(`saleAvailability.${variation.saleAvailability.status}.label`) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="c-modalCard__footer">
        <button type="button" class="btn btn--info" v-on:click="cancel()">Fechar</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  export default {
    data: () => ({
      modal: null,
      isVisible: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      product: {
        type: Object,
        required: true
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      confirm () {
        this.$emit('option', true)
        this.close()
      },
      cancel () {
        this.close()
      },
      close (emit) {
        delete document.body.onkeyup
        delete this.modal.onclick

        this.isVisible = false
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    }
  }
</script>

<style lang="sass" scoped>
  .img-product
    text-align: center

    &::before
      content: ''
      display: inline-block
      vertical-align: middle
      height: 100%

    img
      max-width: 85%

  strong
    display: block

  .variation
    margin-bottom: 16px
    border-bottom: 1px solid #ccc
    padding-bottom: 16px

    &:last-child
      border-bottom: none
      padding-bottom: 0
      margin-bottom: 0

  .oldPrice
    color: #9a9a9a
    font-size: 13px

  .newPrice
    font-size: 16px

  .margin
    margin-bottom: 15px
</style>

<style lang="sass">
  .c-modal__content
    max-width: 850px
</style>



// WEBPACK FOOTER //
// VariationModal.vue?75371c59